import { getLocale } from 'next-intl/server'
import { defaultLocale } from '@i18n/config'
import { countryAlias } from '@lib/config'
import { fetchData, getRealLang } from './lib'

async function serverFetchData(method, apiUrl, query, options, token, uuid) {
  let lang = defaultLocale
  try { lang = await getLocale() } catch(err) { /**/ }

  const serverOptions = {
    headers: {
      'Accept-Language': getRealLang(lang),
      countryiso: process.env.NEXT_PUBLIC_COUNTRY || countryAlias.nz
    },
    ...options,
  }
  return fetchData(method, apiUrl, query, serverOptions, token, uuid, true)
}

export function fetchGet(...args) {
  return serverFetchData('get', ...args)
}

export function fetchPost(...args) {
  return serverFetchData('post', ...args)
}

export function fetchPut(...args) {
  return serverFetchData('put', ...args)
}

export function fetchDelete(...args) {
  return serverFetchData('delete', ...args)
}
